<template>
  <section v-if="games.length" class="seo-section" id="most-played-this-week">
    <h2>Most Played Games This Week</h2>
    <p>
      The games steamplayti.me players spent the most hours in, {{ range }}.
    </p>
    <ol class="insight-games">
      <li v-for="game in games" :key="game.appId" class="insight-game">
        <span class="insight-game-rank">{{ game.rank }}</span>
        <img
          class="insight-game-img"
          :src="gameHeaderUrl(game)"
          :alt="game.name"
          loading="lazy"
          @error="$event.target.style.visibility='hidden'"
        >
        <span class="insight-game-name">{{ game.name }}</span>
        <span class="insight-game-players">{{ game.players.toLocaleString('en-US') }} players</span>
        <span class="insight-game-hours">{{ formatHours(game.totalMinutes) }}</span>
      </li>
    </ol>
    <p class="insight-note">Updated daily from the play history of everyone who uses steamplayti.me.</p>
  </section>
</template>

<script>
import { loadSiteInsights, formatHours, formatRange, gameHeaderUrl } from '../utils/siteInsights';

export default {
  name: 'SeoTopGamesInsights',
  data() {
    return { topGames: null };
  },
  computed: {
    games() {
      return this.topGames?.games || [];
    },
    range() {
      return formatRange(this.topGames.from, this.topGames.to);
    },
  },
  async mounted() {
    const insights = await loadSiteInsights();

    this.topGames = insights?.topGames || null;
  },
  methods: {
    formatHours,
    gameHeaderUrl,
  },
};
</script>

<style scoped>
.insight-games {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.insight-game {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 10px 14px;
  background: var(--panel);
  border: 1px solid var(--panel-border);
  border-radius: 12px;
}

.insight-game-rank {
  width: 22px;
  color: var(--muted);
  font-weight: 700;
  text-align: right;
  flex-shrink: 0;
}

.insight-game-img {
  width: 92px;
  height: 43px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}

.insight-game-name {
  flex: 1;
  min-width: 0;
  color: var(--text);
  font-weight: 600;
  /* Wraps rather than ellipsis: a nowrap name's full width becomes the whole
     page's min-content through the column-flex chain and overflows phones. */
  overflow-wrap: anywhere;
}

.insight-game-players {
  color: var(--muted);
  font-size: 0.85rem;
  flex-shrink: 0;
}

.insight-game-hours {
  color: var(--primary);
  font-weight: 700;
  min-width: 56px;
  text-align: right;
  flex-shrink: 0;
}

.seo-section .insight-note {
  font-size: 0.85rem;
}

@media (max-width: 600px) {
  .insight-game-img,
  .insight-game-players {
    display: none;
  }
}
</style>
